import React, { ReactNode } from 'react';
import cx from 'classnames';
import { NavStep } from '../Screen';
import Button, { ButtonProps } from './Button';
import { Helmet } from 'react-helmet';

export interface PageTitleAndNavProps {
  titleText: string | null;
  title: string | ReactNode | null;
  titleRightSide: ReactNode | null;
  currentStep: string | null;
  currentSubStep: string | null;
  steps: Record<string, NavStep> | null;
  actions: (
    ButtonProps[]
    | {
      left?: ButtonProps[];
      right?: ButtonProps[];
    }
  );
  handleStepChange: (step: string) => void;
  handleSubStepChange: (step: string) => void;
}

export default function PageTitleAndNav({
  titleText,
  title,
  titleRightSide,
  currentStep,
  currentSubStep,
  steps,
  actions,
  handleStepChange,
  handleSubStepChange,
}: PageTitleAndNavProps) {
  const subSteps = steps?.[currentStep as keyof typeof steps]?.subSteps;

  return (<>
    {titleText && (
      <Helmet>
        <title>{titleText}</title>
      </Helmet>
    )}

    <div className="flex flex-row gap-2 bg-white border-b border-t border-gray-200 px-4 py-4 text-2xl font-medium text-gray-900 overflow-auto">
      {title && (
        <h1 className="flex-1">
          {title}
        </h1>
      )}
      {titleRightSide && (
        <div>
          {titleRightSide}
        </div>
      )}
    </div>

    {steps && (
      <nav className="bg-white z-10 sticky py-2 top-0 border-b border-gray-200 px-4 flex justify-start w-full">
        {Object.keys(steps).map((stepName, index) => {
          const isCurrent = currentStep === stepName;
          // const isCompleted = STEPS.indexOf(currentStep) > index;

          return (
            <React.Fragment key={stepName}>
              <button
                onClick={() => handleStepChange(stepName)}
                className={cx(
                  `font-medium mr-1 cursor-pointer`
                )}
              >
                <span
                  className={cx(
                    `flex items-center rounded-4xl text-lg px-4 py-2 font-medium transition-colors duration-200`,
                    isCurrent
                      ? 'bg-gradient-to-tr from-yellow-500 to-yellow-200 hover:from-yellow-400 hover:to-yellow-100 text-gray-900'
                      : 'bg-white text-gray-900 hover:bg-gray-200 cursor-pointer'
                  )}
                >
                  {steps[stepName as keyof typeof steps].icon && <span className="mr-2">{steps[stepName as keyof typeof steps].icon}</span>}
                  {steps[stepName as keyof typeof steps].label}
                </span>
              </button>
            </React.Fragment>
          );
        })}
        
        {/* // TODO: Add actions to the title and nav */}
        {/* <div className="flex-1" />
        {actions && actions.map((action, index) => (
          <Button key={index} {...action} />
        ))} */}
      </nav>
    )}

    {subSteps && (
      <nav className="bg-white border-b border-gray-200 px-4 flex justify-start w-full">
      {Object.keys(subSteps).map((stepName, index) => {
        const isCurrent = currentSubStep === stepName;
        // const isCompleted = STEPS.indexOf(currentStep) > index;

        return (
          <React.Fragment key={stepName}>
            <button
              onClick={() => handleSubStepChange(stepName)}
              className={cx(
                `py-2 font-medium mr-1`
              )}
            >
              <span
                className={cx(
                  `flex items-center rounded-4xl text-lg px-4 py-2 font-medium transition-colors duration-200`,
                  isCurrent
                    ? 'bg-yellow-400 text-gray-900'
                    : 'bg-white text-gray-900 hover:bg-gray-200 cursor-pointer'
                )}
              >
                {subSteps[stepName as keyof typeof subSteps].icon && <span className="mr-2">{subSteps[stepName as keyof typeof subSteps].icon}</span>}
                {subSteps[stepName as keyof typeof subSteps].label}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </nav>
    )}

    {actions && false === Array.isArray(actions) && (
      <div className="flex gap-2 p-4">
        {actions.left && actions.left.map((action, index) => (
          <Button key={index} {...action} />
        ))}
        <div className="flex-1" />
        {actions.right && actions.right.map((action, index) => (
          <Button key={index} {...action} />
        ))}
      </div>
    )}

    {actions && Array.isArray(actions) && (
      <div className="flex gap-2 p-4">
        {actions.map((action, index) => (
          <Button key={index} {...action} />
        ))}
      </div>
    )}
  </>);
}